import { FC } from 'react'
import { useCustomTheme } from '@/core/theme'
import LinkButton from '@/ui/components/buttons/link/linkButton'
import Typography from '@/ui/components/typography'
import { ChatCallout } from '@ui/drawer/common/ChatCallout'
import {
    CardHeader,
    CardWrapper,
    StepItem,
    StepsList,
} from './RemediationStepsCard.styles'
import { RemediationStepsCardProps } from './RemediationStepsCard.types'

const RemediationStepsCard: FC<RemediationStepsCardProps> = ({
    issue,
    title = 'How to resolve:',
}) => {
    const theme = useCustomTheme()
    const {
        resolution_url: resolutionUrl,
        remediation_steps: remediationSteps,
    } = issue

    return (
        <CardWrapper data-testid="remediation-steps-card">
            <CardHeader>
                <Typography
                    variant="s-semibold"
                    color={theme.colors.greys[800]}
                >
                    {title}
                </Typography>
                {resolutionUrl && (
                    <LinkButton
                        external={true}
                        text="Remediation guide"
                        to={resolutionUrl}
                        variant="s-semibold"
                    />
                )}
            </CardHeader>
            {remediationSteps && remediationSteps.length > 0 && (
                <StepsList data-testid="remediation-steps-list">
                    {remediationSteps.map((step, index) => (
                        <StepItem key={index}>
                            <Typography
                                variant="s-regular"
                                noWrap={false}
                                color={theme.colors.greys[800]}
                            >
                                {step}
                            </Typography>
                        </StepItem>
                    ))}
                </StepsList>
            )}
            <ChatCallout issue={issue} />
        </CardWrapper>
    )
}

export default RemediationStepsCard
